import _inRange from "lodash/inRange";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import React, { cloneElement, Children } from 'react';
import PropTypes from 'prop-types';
import { COLUMN_DISPLAY_NAME } from './Col';
import { containerStyle, rowComp } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var NUMBER_OF_COLUMNS = 12;
export var ROW_DISPLAY_NAME = 'GridRow';

var Row = function Row(props) {
  var toArray = Children.toArray;
  var initChilds = props.children,
      xs = props.xs,
      sm = props.sm,
      md = props.md,
      lg = props.lg,
      xl = props.xl;
  var gap = props.gap,
      verticalGap = props.verticalGap,
      horizontalGap = props.horizontalGap,
      container = props.container,
      className = props.className;
  var children = toArray(initChilds).filter(Boolean);

  var getValidSize = function getValidSize(size) {
    return _inRange(size, 1, NUMBER_OF_COLUMNS + 1) || size === 'auto' ? size : null;
  };

  var getColumnSize = function getColumnSize(el, type) {
    return getValidSize(el.props[type] || 0);
  };

  var columnChildren = children.map(function (el, i) {
    var _el$props$__EMOTION_T;

    var type = (_el$props$__EMOTION_T = el.props.__EMOTION_TYPE_PLEASE_DO_NOT_USE__) !== null && _el$props$__EMOTION_T !== void 0 ? _el$props$__EMOTION_T : el.type;
    return (type === null || type === void 0 ? void 0 : type.displayName) === COLUMN_DISPLAY_NAME ? /*#__PURE__*/cloneElement(el, {
      key: "Column".concat(i),
      gap: gap !== null && gap !== void 0 ? gap : el.props.gap,
      verticalGap: verticalGap !== null && verticalGap !== void 0 ? verticalGap : el.props.verticalGap,
      horizontalGap: horizontalGap !== null && horizontalGap !== void 0 ? horizontalGap : el.props.horizontalGap,
      xs: getColumnSize(el, 'xs') || getValidSize(xs),
      sm: getColumnSize(el, 'sm') || getValidSize(sm),
      md: getColumnSize(el, 'md') || getValidSize(md),
      lg: getColumnSize(el, 'lg') || getValidSize(lg),
      xl: getColumnSize(el, 'xl') || getValidSize(xl)
    }) : el;
  });

  var rowComponent = ___EmotionJSX("div", _extends({}, className && {
    className: className
  }, {
    css: rowComp(props)
  }), columnChildren);

  return container ? ___EmotionJSX("div", {
    css: containerStyle(props)
  }, rowComponent) : rowComponent;
};

Row.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  container: PropTypes.bool,
  className: PropTypes.string,
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xl: PropTypes.number,
  gap: PropTypes.number,
  verticalGap: PropTypes.number,
  horizontalGap: PropTypes.number
};
Row.displayName = ROW_DISPLAY_NAME;
export default Row;